import { Handshake, Scale, Lock } from "lucide-react";

const ITEMS = [
  { icon: Handshake, text: "Fini la pression commerciale" },
  { icon: Scale, text: "Données & prix de marché réels" },
  { icon: Lock, text: "Gardez le contrôle (100% sans engagement)" },
];

export const Marquee = () => {
  // On duplique la liste pour un défilement continu sans coupure.
  const loop = [...ITEMS, ...ITEMS, ...ITEMS, ...ITEMS];
  return (
    <div className="w-full bg-blue-50/70 border-b border-blue-100 overflow-hidden" data-testid="top-marquee">
      <div className="flex whitespace-nowrap animate-marquee py-2">
        {loop.map((it, i) => (
          <div key={i} className="flex items-center gap-2 px-6 shrink-0" data-testid="marquee-item">
            <it.icon className="w-4 h-4 text-[#2563EB]" strokeWidth={2} />
            <span className="text-sm font-medium text-slate-700">{it.text}</span>
            <span className="ml-6 text-blue-200">•</span>
          </div>
        ))}
      </div>
    </div>
  );
};
